export default __webpack_public_path__ + "static/media/markAsRead.19580019.svg";